import { ButtonIcon } from '@storeblocks/button';
import { type FC } from 'react';
import styled from 'styled-components';

import { TrackingElement, useGetTrackId } from '@/tracking';

interface Props {
  disabled?: boolean;
  onEdit: () => void;
  onDelete: () => void;
  alignRight?: boolean;
  actionContext: string;
  id?: string;
}

export const EditAndDeleteButtons: FC<Props> = ({
  disabled = false,
  onEdit,
  onDelete,
  alignRight = false,
  actionContext,
  id,
}) => {
  const getTrackId = useGetTrackId();

  return (
    <Wrapper alignRight={alignRight}>
      <ButtonIcon
        disabled={disabled}
        onClick={disabled ? undefined : onEdit}
        iconName="edit"
        size="medium"
        label="Edit"
        data-trackid={getTrackId(
          `edit-${actionContext}`,
          TrackingElement.Button,
        )}
        data-test={`edit-button-${id}`}
      />
      <ButtonIcon
        disabled={disabled}
        iconName="delete"
        size="medium"
        label="Delete"
        onClick={disabled ? undefined : onDelete}
        data-trackid={getTrackId(
          `delete-${actionContext}`,
          TrackingElement.Button,
        )}
        data-test={`delete-button-${id}`}
      />
    </Wrapper>
  );
};

interface WrapperProps {
  alignRight: boolean;
}

const Wrapper = styled.div<WrapperProps>`
  display: flex;
  flex-flow: row;
  gap: 32px;
  justify-content: ${(props) => (props.alignRight ? 'flex-end' : 'flex-start')};
`;
